import * as React from 'react';
import { AdministrationStores } from '../stores';
import { observer } from 'mobx-react-lite';
import { Button, Dropdown, Layout, Menu } from 'antd';
import WrappedAddUserDialog from './AddUserDialog';
// import UserManagerTree from './UserManagerTree';
// import WrappedUserContent from './UserContent';
import LayoutHeader from '../../../components/LayoutHeader';
import UsersList from './UsersList';
import EditUserDialog from './EditUserDialog';
import BulkUsersDialog from './BulkUsersDialog';

type Props = AdministrationStores;

export const Users: React.FC<Props> = ({ UsersManager: store }) => {
    React.useEffect(() => {
        store!.init().catch(err => console.error(err));
        store!.getUsers().catch(err => console.error(err));
        store!.getCustomRoles().catch(err => console.error(err));
    }, [store]);

    const layout = (
        // {/* <Sider data-id="user-manager-side-section" width={350} style={{background: 'white', overflow: 'auto'}}>
        //     <WrappedAddUserDialog UsersManager={store}/>
        //     <Button data-id="user-manager-add-user-button" style={{marginLeft: 9}} type="primary"  onClick={() => store!.setIsAddUserDialogVisible(true)}>Add User</Button>
        //     <UserManagerTree UsersManager={store}/>
        // </Sider> */}
        <Layout className="screen-size" style={{ ...{ height: '100%', background: 'white', overflow: 'hidden' } }}>
            <WrappedAddUserDialog UsersManager={store} />
            <EditUserDialog UsersManager={store} />
            <BulkUsersDialog store={store!} />
            <LayoutHeader
                title="User management"
                helpMessage="You can manage users and their roles here."
                buttons={[
                    <Button
                        key="user-manager-add-user-button"
                        data-id="user-manager-add-user-button"
                        type="primary"
                        size="large"
                        onClick={() => store!.setIsAddUserDialogVisible(true)}
                    >
                        Add user
                    </Button>,
                    <Dropdown
                        key="user-manager-add-users-bulk-button"
                        overlay={
                            <Menu>
                                <Menu.Item key="template" onClick={() => store!.downloadBulkUsersTemplate()}>
                                    Get User Template
                                </Menu.Item>
                                <Menu.Item
                                    key="import"
                                    onClick={() => store!.setBulkUsersDialogVisible(true, 'import')}
                                >
                                    Import User List
                                </Menu.Item>
                                <Menu.Item
                                    key="export"
                                    onClick={() => store!.setBulkUsersDialogVisible(true, 'export')}
                                >
                                    Export Credentials Sheet
                                </Menu.Item>
                            </Menu>
                        }
                    >
                        <Button data-id="user-manager-add-users-bulk-button" size="large">
                            Add Users in Bulk
                        </Button>
                    </Dropdown>
                ]}
            />
            <Layout.Content>
                {/* {store!.selectedUser ? <WrappedUserContent UsersManager={store}/> : <></>} */}
                <UsersList store={store!} />
            </Layout.Content>
        </Layout>
    );

    return layout;
};

export default observer(Users);
